'use strict';
angular.module('cvsApp').factory('validateOrderModel',['commonModel',function(CM) {

	var getValidateOrderModel = function(){

		var self = this;
		var response;

		var apiResponse = {};

		this.setResponse = function(data){
			response = data;
		}

		this.getResponse = function(){
			apiResponse = response.validateOrderResponse;
			return self;
		}

		this.showView = function(){
			if(apiResponse.isViewError){
				return !apiResponse.isViewError;
			}
			return true;
		}

		this.getError = function(){
			if(apiResponse.header.statusCode !== "CODE_00_SUCCESS" && apiResponse.header.statusCode !== "0000"){
				return apiResponse.header;
			}
			return "";
		}

		this.getHeader = function () {
			return apiResponse.header;
		}

		this.getValidateOrderDetails = function(){
			if(this.getError()==""){
				return apiResponse.details;
			}
			return apiResponse.header;
		}

	}

	return new getValidateOrderModel();
}]);
